import dayjs from 'dayjs';

const setDateLocale = async (locale = 'en') => {
  try {
    switch (locale) {
      case 'pt-br':
        await import('dayjs/locale/pt-br');
        break;

      case 'en':
      default:
        await import('dayjs/locale/en');
        break;
    }

    dayjs.locale(locale);
  } catch (error) {
    console.warn(`Locale ${locale} not found. Falling back to 'en'.`, error);

    dayjs.locale('en');
  }
};

export default setDateLocale;
